import { InnerBox } from "@/components/elements/InnerBox";
import { Grid, Stack } from "@mui/material";
import { FC } from "react";
import { JobFormTitle } from "@/features/job/components/job-form/JobFormTitle";
import { TJobForm } from "@/features/job/types/JobForm";
import { JobInfoItem } from "@/features/job/components/job-detail/JobInfoItem";
import { JobObjectFieldsDetail } from "@/features/job/components/job-detail/JobObjectFieldsDetail";

type TJobFeatureDetailProps = {
  defaultValues?: Partial<TJobForm>;
};

export const JobFeatureDetail: FC<TJobFeatureDetailProps> = ({ defaultValues }) => {
  return (
    <Stack gap={2}>
      <InnerBox title={<JobFormTitle text="求人特徴" />} padding="24px" showDivider={false}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <JobObjectFieldsDetail title="本人負担費用" data={defaultValues?.selfExpense} />
          </Grid>
          <Grid item xs={12}>
            <JobInfoItem label="求人企業の特徴（選考ポイント）" value={defaultValues?.companyFeatures} type="textArea" isShowDivider={false} />
          </Grid>
          <Grid item xs={6}>
            <JobInfoItem label="在籍外国人" value={defaultValues?.foreignEmployees} type="textArea" isShowDivider={false} />
          </Grid>
          <Grid item xs={6}>
            <JobObjectFieldsDetail title="受け入れ体制・サポート" data={defaultValues?.onboardingSupport} />
          </Grid>
        </Grid>
      </InnerBox>
    </Stack>
  );
};
